import apiClient from './apiClient';

const URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api') + '/enlaces';

/**
 * Obtiene el listado de enlaces con soporte para filtros opcionales.
 * @param {Object} filter { tarjeta_id?: number, tipo_acceso_id?: number, es_entorno_test?: boolean }
 */
export const getEnlaces = async (filter = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (filter.tarjeta_id !== undefined && filter.tarjeta_id !== null) {
      queryParams.append('tarjeta_id', String(filter.tarjeta_id));
    }
    if (filter.tipo_acceso_id !== undefined && filter.tipo_acceso_id !== null) {
      queryParams.append('tipo_acceso_id', String(filter.tipo_acceso_id));
    }
    if (filter.es_entorno_test !== undefined && filter.es_entorno_test !== null) {
      queryParams.append('es_entorno_test', String(filter.es_entorno_test));
    }
    const queryString = queryParams.toString();
    const endpoint = queryString ? `${URL}?${queryString}` : URL;

    const response = await apiClient(endpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || 'Error al obtener los enlaces');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Obtiene un enlace por su ID con sus detalles asociados.
 * @param {number|string} id
 */
export const getEnlaceById = async (id) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al obtener el enlace ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Crea un nuevo enlace.
 * @param {Object} enlaceData { nombre: string, url: string, tarjeta_id: number, tipo_acceso_id: number, es_entorno_test?: boolean }
 */
export const postEnlace = async (enlaceData) => {
  try {
    const response = await apiClient(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(enlaceData),
    });
    const data = await response.json();
    if (response.status !== 201) {
      throw new Error(data.message || 'Error al crear el enlace');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Actualiza un enlace existente por su ID.
 * @param {number|string} id
 * @param {Object} enlaceData
 */
export const putEnlace = async (id, enlaceData) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(enlaceData),
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al actualizar el enlace ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Elimina un enlace por su ID.
 * @param {number|string} id
 */
export const deleteEnlace = async (id) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al eliminar el enlace ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};
